import React from 'react';
import './examNavigation.scss';

const ExamNavigation = ({ sections, activeSection, onSectionChange, isSwitchable }) => {
  return (
    <div className="exam-navigation">
      <div className="exam-navigation__wrapper">
        <div className="exam-navigation__label">SECTIONS</div>
        <div className="exam-navigation__scroll">
          {sections?.map((section) => (
            <button
              key={section._id}
              className={`exam-navigation__button ${
                activeSection === section.title ? 'active' : ''
              }`}
              onClick={() => onSectionChange(section)}
            >
              {section.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamNavigation;
